export const version = '2.39.2';
//# sourceMappingURL=version.js.map